import { useProductCompleteStore } from '@/features/Product/stores/productComplete';
import { useProductBaseStore } from '@/features/Product/stores/productBase';
import { useProductBundleStore } from '@/features/Product/stores/productBundle';
import type { ProductComplete } from '@/features/Product/types/models';

export const getProductBySku = (sku: string): ProductComplete | null => {
  const productBaseStore = useProductBaseStore();
  const productBundleStore = useProductBundleStore();
  const productCompleteStore = useProductCompleteStore();

  return (
    productBaseStore.completeBaseProducts.find((p) => p.attributes.sku === sku) ??
    productBundleStore.completeBundleProducts.find((p) => p.attributes.sku === sku) ??
    productCompleteStore.getCompleteProduct('attributes.sku', sku) ??
    null
  );
};

export const getVariantIdBySku = (sku: string): number | null =>
  getProductBySku(sku)?.attributes.variantId ?? null;

export const getProductByVariantId = (variantId: number): ProductComplete | null => {
  const productBaseStore = useProductBaseStore();
  const productBundleStore = useProductBundleStore();
  const productCompleteStore = useProductCompleteStore();
  const hasVariantId = (product: ProductComplete) => product.attributes.variantId === variantId;

  return (
    productBaseStore.completeBaseProducts.find(hasVariantId) ??
    productBundleStore.completeBundleProducts.find(hasVariantId) ??
    productCompleteStore.getCompleteProduct('attributes.variantId', variantId) ??
    null
  );
};
